// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section id="customer-deposit-accounts-cash-action" class="box product-operation" ng-if="\$ctrl.deposit">
    <sub-header header="'Partial withdrawal with check'"></sub-header>

    <div class="info info--deposit">
      <div class="info__field">
        <span class="info__field-label">Product name:</span>
        <span class="info__field-value">{{\$ctrl.deposit.productDefinition.productName}}</span>
      </div>
      <div class="info__field">
        <span class="info__field-label">Product number:</span>
        <span class="info__field-value">{{\$ctrl.deposit.productNumber}}</span>
      </div>
      <div class="info__field">
        <span class="info__field-label">Available balance:</span>
        <span class="info__field-value">{{\$ctrl.deposit.balance | nxCurrency}}</span>
      </div>
      <div class="info-detail">
        <span class="key">Minimum balance:</span>
        <span class="value">{{\$ctrl.deposit.depositType.minimalBalance | nxCurrency}}</span>
      </div>
      <div class="info__field">
        <span class="info__field-label">Override withdraw amount:</span>
        <span class="info__field-value"><input type="checkbox" ng-model="\$ctrl.overrideCheckbox" ng-change="\$ctrl.setDefaultWithdrawalAmount(); \$ctrl.requireSimulation(); \$ctrl.setOverrideMaxWithdrawalAmount()"/></span>
      </div>
    </div>

    <h2 class="section-header">Please confirm the following:</h2>

    <form name="\$ctrl.transactionForm">
      <table class="misc-transaction__table table">
        <tbody>
          <tr>
            <td></td>
            <td>Check number</td>
            <td>
              <input
                required
                type="text"
                minlength="10"
                maxlength="10"
                ui-mask="9999999999"
                ng-model="\$ctrl.request.checkNumber"
                ng-change="\$ctrl.updateMicr()"/>
            </td>
          </tr>
        <tr>
          <td></td>
          <td>Depository account</td>
          <td>
            <selectize
              required
              options="\$ctrl.depositoryAccounts"
              config="\$ctrl.accountSelectConfig"
              ng-model="\$ctrl.request.depositoryAccountId"
              ng-change="\$ctrl.onDepositoryAccountChange()">
            </selectize>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Account number</td>
          <td>
            <input
              disabled
              required
              type="text"
              minlength="12"
              maxlength="12"
              ng-model="\$ctrl.request.accountNumber"/>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>BRSTN</td>
          <td>
            <input
              disabled
              required
              type="text"
              minlength="9"
            maxlength="9"
            ng-model="\$ctrl.request.brstn"/>
          </td>
        </tr>
      <tr>
        <td></td>
        <td>MICR number</td>
        <td>
          <input
            required
            disabled
            type="text"
            class="check-no"
            ng-model="\$ctrl.request.micrNumber"
            ui-mask="&#x2448;9999999999&#x2448;99999&#x2449;9999&#x2446;999999999999&#x2448;"/>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>Valid from</td>
        <td>
          <date output-format="date"
                ng-required="true"
                ng-model="\$ctrl.request.validFrom"></date>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>Payee</td>
        <td>
          <input
            required
            type="text"
            ng-model="\$ctrl.request.payee"/>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>Remarks</td>
        <td>
          <input
            type="text"
            ng-model="\$ctrl.request.remarks"
            ng-required="false">
        </td>
      </tr>
      </tbody>
      </table>
      <table class="misc-transaction__table table table--generate-row-ids">
        <thead>
        <tr ng-if="\$ctrl.overrideCheckbox">
          <td></td>
          <td></td>
          <td ng-if="\$ctrl.overrideCheckbox">
            Default
          </td>
          <td ng-if="\$ctrl.overrideCheckbox">
            Overridden
          </td>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td></td>
          <td>Gross interest:</td>
          <td>
            <cash ng-model="\$ctrl.interestForecast.interest"
              ng-disabled="true"></cash>
          </td>
          <td ng-if="\$ctrl.overrideCheckbox">
            <cash ng-disabled="true" ng-model="\$ctrl.override.grossInterest">
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Withholding tax:</td>
          <td>
            <cash ng-model="\$ctrl.interestForecast.withholdingTax"
              ng-disabled="true"></cash>
          </td>
          <td ng-if="\$ctrl.overrideCheckbox">
            <cash ng-model="\$ctrl.override.withholdingTax"
                  ng-change="\$ctrl.recalculateOverrideGrossInterestAndMaxWithdrawalAmount(); \$ctrl.requireSimulation()"
                  ng-required="true"
                  min="0"></cash>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Net interest:</td>
          <td>
            <cash ng-model="\$ctrl.interestForecast.netInterest"
              ng-disabled="true"></cash>
          </td>
          <td ng-if="\$ctrl.overrideCheckbox">
            <cash ng-model="\$ctrl.override.netInterest"
                  ng-change="\$ctrl.recalculateOverrideGrossInterestAndMaxWithdrawalAmount(); \$ctrl.requireSimulation()"
                  min="0"></cash>
          </td>
        </tr>
        <tr ng-repeat="fee in \$ctrl.interestForecast.terminationFees">
          <td></td>
          <td>{{fee.feeName}}</td>
          <td>
            <cash ng-model="fee.amount" ng-disabled="true"></cash>
          </td>
          <td ng-if="\$ctrl.overrideCheckbox">
            <cash ng-model="fee.overrideAmount"
                  ng-required="true"
                  ng-change="\$ctrl.recalculateOverrideGrossInterestAndMaxWithdrawalAmount(); \$ctrl.requireSimulation()"></cash>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Max withdrawal amount:</td>
          <td>
            <cash ng-model="\$ctrl.maxWithdrawalAmount"
                  ng-disabled="true"></cash>
          </td>
          <td ng-if="\$ctrl.overrideCheckbox">
            <cash ng-model="\$ctrl.override.maxWithdrawalAmount"
                  ng-disabled="true"></cash>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Withdraw amount:</td>
          <td>
            <cash ng-model="\$ctrl.request.amount"
                  ng-disabled="\$ctrl.overrideCheckbox"
                  ng-required="true"
                  max="\$ctrl.maxWithdrawalAmount"
                  ng-change="\$ctrl.requireSimulation()"></cash>
          </td>
          <td ng-if="\$ctrl.overrideCheckbox">
            <cash ng-model="\$ctrl.override.amount"
                  max="\$ctrl.override.maxWithdrawalAmount"
                  ng-required="true"
                  ng-change="\$ctrl.requireSimulation()"></cash>
          </td>
        </tr>
        <tr ng-repeat="fee in \$ctrl.beforeRolloverFees">
          <td></td>
          <td>{{fee.feeName}}</td>
          <td>
            <cash ng-model="fee.amount" ng-disabled="true"></cash>
          </td>
          <td ng-if="\$ctrl.overrideCheckbox">
            <cash ng-model="fee.overrideAmount"
                  ng-required="true"
                  ng-change="\$ctrl.recalculateOverrideGrossInterestAndMaxWithdrawalAmount(); \$ctrl.requireSimulation()" ></cash>
          </td>
        </tr>
        <tr ng-repeat="fee in \$ctrl.afterRolloverFees">
          <td></td>
          <td>{{fee.feeName}}</td>
          <td>
            <cash ng-model="fee.amount" ng-disabled="true"></cash>
          </td>
          <td ng-if="\$ctrl.overrideCheckbox">
            <cash ng-model="fee.overrideAmount"
                  ng-required="true"
                  ng-change="\$ctrl.recalculateOverrideGrossInterestAndMaxWithdrawalAmount(); \$ctrl.requireSimulation()"></cash>
          </td>
        </tr>
        <tr ng-if="\$ctrl.netRolloverAmount || \$ctrl.override.netRolloverAmount">
          <td></td>
          <td>Rollover amount:</td>
          <td>
            <cash ng-model="\$ctrl.netRolloverAmount"
                  ng-disabled="true"></cash>
          </td>
          <td ng-if="\$ctrl.overrideCheckbox">
            <cash ng-model="\$ctrl.override.netRolloverAmount"
                  ng-disabled="true"></cash>
          </td>
        </tr>
        </tbody>
      </table>

      <div ng-if="\$ctrl.simulationErrors.length > 0">
        <dynamic-list
          generate-row-ids="false"
          columns="\$ctrl.formatErrorColumns"
          data="\$ctrl.simulationErrors"
          list-type="'ERROR'">
        </dynamic-list>
      </div>

      <div class="buttons">
        <signature-card
          file-id="\$ctrl.deposit.signatureCardFileId"
          product-group="'DEPOSIT'"
          product-status="\$ctrl.deposit.status"></signature-card>
        <button
          class="btn btn-warning"
          ng-click="\$ctrl.redirectBack()">
          Cancel
        </button>
        <button
          class="btn btn-primary"
          ng-click="\$ctrl.simulatePartialWithdrawal()"
          ng-disabled="\$ctrl.isSimulatePartialWithdrawalDisabled()">
          Simulate
        </button>
        <button
          class="btn btn-primary"
          ng-click="\$ctrl.partialWithdrawal()"
          ng-disabled="\$ctrl.isPartialWithdrawalDisabled()">
          Withdraw
        </button>
      </div>
    </form>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/term-deposits/partial-withdrawal-check/partial-withdrawal-check.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;